export interface ProductDetails {
  id: string;
  title: string;
  description: string;
  sizes?: string[];
  colors?: string[];
  defaultImage: string;
  defaultColor?: string;
  price: number;
  currency: string;
  recommendedProductIds: string[];
  imagesByColor?: Record<string, string>;
}

export const allProducts: ProductDetails[] = [
  {
    id: "132",
    title: "Something About A Rose T-Shirt",
    description:
      "Think of it as a blank canvas. Cut it, crop it, tie it - make it as loud or as soft as you",
    defaultImage: "/images/white-t-shirt-orange-bg.png",
    defaultColor: "White",
    price: 200,
    currency: "GHS",
    sizes: ["M", "L", "XL", "2XL", "3XL"],
    colors: ["Black", "White"],
    recommendedProductIds: ["133", "134", "135"],
    imagesByColor: {
      Black: "/images/black-t-shirt-orange-bg.png",
      White: "/images/white-t-shirt-orange-bg.png",
    },
  },
  {
    id: "133",
    title: "Something About A Rose Fitted Tee",
    description:
      "For when you’re feeling like your confident, cute self. Snug, simple, and fits like a warm hug.",
    defaultImage: "/images/white-fitted-tee-orange-bg.png",
    defaultColor: "White",
    price: 150,
    currency: "GHS",
    sizes: ["Small", "Medium", "Large"],
    colors: ["Black", "White", "Cream"],
    recommendedProductIds: ["132", "134", "135"],
    imagesByColor: {
      Black: "/images/black-fitted-tee-orange-bg.png",
      White: "/images/white-fitted-tee-orange-bg.png",
      Cream: "/images/nude-fitted-tee-orange-bg.png",
    },
  },
  {
    id: "134",
    title: "Rose Petal Chokers",
    description:
      "A Rosalinda essential. Wear it as a choker, bracelet, hair accessory (points to you if you find a unique way to rock it)",
    defaultImage: "/images/blue-chokers-orange-bg.png",
    defaultColor: "Blue",
    price: 50,
    currency: "GHS",
    sizes: ["One size"],
    colors: ["Blue", "Pink"],
    recommendedProductIds: ["132", "133", "135"],
    imagesByColor: {
      Blue: "/images/blue-chokers-orange-bg.png",
      Pink: "/images/pink-chokers-orange-bg.jpeg",
    },
  },
  {
    id: "135",
    title: "Something About A Rose Tote Bags",
    description:
      "Your dependable baby. Carries snacks, journals, heartbreak, joy (whatever your day looks like)",
    defaultImage: "/images/beige-tote-bag-orange-bg.png",
    defaultColor: "Beige",
    price: 70,
    currency: "GHS",
    sizes: ["One size"],
    colors: ["Beige", "Black"],
    recommendedProductIds: ["132", "133", "134"],
    imagesByColor: {
      Beige: "/images/beige-tote-bag-orange-bg.png",
      Black: "/images/black-tote-bag-orange-bg.png",
    },
  },
  {
    id: "136",
    title: "Something About A Rose Scarf",
    description:
      "A little portal into the wonderful world of Anabel Rose. Wrap it, drape it, or hang it on your wall like a canvas.",
    defaultImage: "/images/scarf-orange-bg.png",
    price: 70,
    currency: "GHS",
    sizes: ["36 x 36 inches"],
    recommendedProductIds: ["132", "133", "134", "135"],
  },
];
